// extracted by mini-css-extract-plugin
export default {"logoLarge":"styles_logoLarge__p4-Qm","logoContainer":"styles_logoContainer__jShUG"};